import { Link } from 'react-router-dom';

const FOOTER_COLUMNS = [
    {
        label: 'Product',
        links: [
            { path: '/avenbox', label: 'AvenBox' },
            { path: '/technology', label: 'Technology' },
            { path: '/security', label: 'Security & Privacy' },
            { path: '/use-cases', label: 'Use Cases' },
            { path: '/pricing', label: 'Pricing' },
        ],
    },
    {
        label: 'Company',
        links: [
            { path: '/about', label: 'About' },
            { path: '/faq', label: 'FAQ' },
            { path: '/contact', label: 'Contact' },
        ],
    },
] as const;

const Footer = () => {
    return (
        <footer className="site-footer">
            <div className="site-width">
                <div className="footer-top">
                    <Link to="/" className="brand-link" style={{ textDecoration: 'none' }}>
                        <img
                            src="/aven-logo-dark.png"
                            alt="Aven Studios logo"
                            className="brand-logo"
                            width={28}
                            height={28}
                        />
                        <span>Aven Studios</span>
                    </Link>
                    <Link to="/contact" className="btn-pill btn-primary footer-reserve-btn">
                        Reserve Position
                    </Link>
                </div>

                <div className="footer-divider" />

                <div className="footer-columns">
                    {FOOTER_COLUMNS.map((col) => (
                        <div key={col.label} className="footer-column">
                            <p className="footer-column__label">{col.label}</p>
                            <nav aria-label={`Footer — ${col.label}`}>
                                {col.links.map((link) => (
                                    <Link key={link.path} to={link.path} className="footer-link footer-link--block">
                                        {link.label}
                                    </Link>
                                ))}
                            </nav>
                        </div>
                    ))}

                    <div className="footer-column footer-column--contact">
                        <p className="footer-column__label">Contact</p>
                        <a href="mailto:hello@avenstudios.com" className="footer-contact">
                            hello@avenstudios.com
                        </a>
                    </div>
                </div>

                <div className="footer-divider" />

                <div className="footer-meta">
                    <p className="footer-copy">Aven Studios s.p. 2026</p>
                    <div className="footer-links">
                        <Link to="/contact" className="footer-link">Contact</Link>
                        <Link to="/faq" className="footer-link">FAQ</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
